import { Flex, Text } from 'components'
import ViewDuplicateListButton from 'modules/shared/ViewDuplicateListButton'

type Props = {
  message: string
  type: 'warning' | 'error'
}

const DuplicateErrorMsg = ({ message, type }: Props) => (
  <Flex gap="0.5rem" mt="0.2rem">
    <Text color={type === 'warning' ? 'yellow' : 'red'}>{message}</Text>
    <ViewDuplicateListButton />
  </Flex>
)

export default DuplicateErrorMsg
